import { Select as SelectPrimitive } from "@base-ui/react/select"
import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

const SelectValue = ({ className, ...props }) => (
  <SelectPrimitive.Value
    data-slot="select-value"
    className={classNames("flex flex-1 items-center truncate", className)}
    {...props}
  />
)

SelectValue.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.node,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
}

export default SelectValue
